<template>
  <v-slide-x-transition mode="out-in">
    <Brand v-if="hasSelectedBrand || id" />
    <Brands v-else />
  </v-slide-x-transition>
</template>

<script>
import Brands from "./Brands"
import Brand from "./Brand"
export default {
  name: "BrandWrapper",
  components: {
    Brands,
    Brand
  },
  computed: {
    id() {
      return this.$route.params.brand
    },
    hasSelectedBrand() {
      return !!this.$store.state.globalBrand?.id
    }
  }
}
</script>

<style scoped></style>
